import 'css-chunksrc/client/scenes/moveElement/projectsSelection/zones/styles.scss';export default {
  "header": "_header_1fmmh_1",
  "title": "_title_1fmmh_10",
  "loader": "_loader_1fmmh_17"
};